import cls from 'classnames';

// ui
import RichText from '@/molecules/RichText/RichText';
// constants
import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

export default function TwoColumnBlockText({ fields, entries } = {}) {
  const { hasTopBorder, leftText, rightText, hasBackground } = fields;

  return (
    <div
      className={cls('aaco-two-column-block-text', {
        'mb-[34px] container mx-auto': !hasBackground,
      })}
    >
      <div
        className={cls({
          'bg-[#000] w-full mb-[7px] md:mb-[14px] h-[1px]': hasTopBorder,
          'md:bg-white md:h-[2px]': hasTopBorder && hasBackground,
        })}
      ></div>
      <div className="flex flex-col md:flex-row md:justify-between md:gap-[50px]">
        {leftText && leftText?.content?.length > 0 && (
          <div className="aaco-two-column-block-text__left md:w-[386px]">
            {leftText.content.map(({ nodeType, content }, index) => (
              <RichText
                entries={entries}
                nodeType={nodeType}
                content={content}
                key={index}
                richTextStyle={{
                  paragraph: {
                    customFont: cls(TEXT_BASE_CLASS.tag, {
                      'text-black': !hasBackground,
                      'text-black md:text-white': hasBackground,
                    }),
                  },
                  paragraphWrapper: 'md:text-left',
                }}
              />
            ))}
          </div>
        )}

        {rightText && rightText?.content?.length > 0 && (
          <div className="aaco-two-column-block-text__right md:w-[163px]">
            {rightText.content.map(({ nodeType, content }, index) => (
              <RichText
                entries={entries}
                nodeType={nodeType}
                content={content}
                key={index}
                richTextStyle={{
                  paragraph: {
                    customFont: cls(TEXT_BASE_CLASS.tag, 'md:text-right', {
                      'text-black': !hasBackground,
                      'text-black md:text-white': hasBackground,
                    }),
                    paragraphWrapper: 'md:text-right',
                  },
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
